angular.module('leanlaw').directive('llInvoiceFormat', ['leanLawApi', '$timeout', 'userService', 'alerts', function (leanLawApi, $timeout, userService, alerts) {
  return {
    restrict: 'EA',
    template: require('./views/format.html'),
    scope: {
      format: '=',
      open: '=',
      fixed: '=',
      client: '=',
      matter: '='
    },
    link(scope, element) {
      scope.$watch('open', (open, prevOpen) => {
        if (open === prevOpen) return;
        $timeout(() => {
          element.find('button').click();
        }, 0, false);
      });
    },
    controller: ['$scope', function ($scope) {
      userService.me().then(me => {
        $scope.me = me;
      });
      $scope.saveClient = function () {
        alerts.dismiss();
        const client = $scope.client || $scope.matter.client;
        if (!client) throw "Requires client";
        $scope.saving = true;
        leanLawApi.updateClient({
          id: client.id,
          body: {
            settings: {
              invoice: formatToSave()
            }
          }
        }).then(client => {
          alerts.success(`Saved this format for ${client.name}`);
        }).finally(() => {
          $scope.saving = false;
        });
      };
      function formatToSave() {
        const format = angular.copy($scope.format);
        delete format.includeFixed;
        delete format.includeNone;
        return format;
      }
    }]
  };
}]);